import Auth0 from 'auth0-js'
import { User, Tenant, UserLanguageCode } from '@/types'

/**
  Starts an Auth0 session for the user

  On success, the user will be redirected to the AuthX /authenticate page
  On failure, an error will be thrown
* */
export const authenticateAgainstAuth0 = (user: User, tenant: Tenant, langCode: UserLanguageCode): Promise<any> => {
  // Note: On success, the below promise will redirect the user
  // (instead of resolving)
  return new Promise((resolve, reject) => {
    if (!user) {
      throw new Error('UserRequired')
    }

    if (!tenant) {
      throw new Error('TenantRequired')
    }

    if (!langCode) {
      throw new Error('LangCodeRequired')
    }

    const webAuth = new Auth0.WebAuth({
      domain: tenant.loginDomain,
      clientID: tenant.loginClientId,
    })

    webAuth.login({
      username: user.email,
      password: user.password,
      redirectUri: `${window.location.protocol}//${window.location.host}/authenticate?langCode=${langCode}&applyMfa=1`,
      scope: 'openid email profile',
      responseType: 'code',
    }, reject)
  })

}
